export const opuc = {
    agencyCode: '475',
    name: 'Office of Public Utility Counsel',
    shortName: 'OPUC',
    slug: 'opuc'
    
    
  };